import httpService from '@/services/httpService'
import _ from 'lodash'
// eslint-disable-next-line no-unused-vars
import BriefsOverview from '../../../features/content-briefs/BriefsOverview'

export const types = {
  ADD_BRIEFS: 'briefs-overview/ADD_BRIEFS',
  ADD_STATUSES: 'breifs-overview/ADD_STATUSES',
  ADD_SECTIONS: 'briefs-overview/ADD_SECTIONS',
  CHANGE_ACTIVE_STATUS: 'briefs-overview/CHANGE_ACTIVE_STATUS',
  CHANGE_ACTIVE_SECTION: 'briefs-overview/CHANGE_ACTIVE_SECTION',
  RESET_BRIEF_DATA: 'briefs-overview/RESET_BRIEF_DATA'
}

export const STATUS_ALL = 'All'
export const SECTION_ALL = 'All'
export const ALLOWED_URL_STATUS_NAMES = ['proposed', 'planned', 'dismissed', 'sidelined', 'published']
const state = {
  briefsList: [],
  activeStatus: STATUS_ALL,
  activeSection: SECTION_ALL,
  statuses: [],
  sections: [],
  filteredStatuses: [],
  filteredSections: []
}

const mutations = {
  [types.ADD_BRIEFS]: function (state, briefs) {
    state.briefsList = briefs || []
    if (briefs.length) {
      const briefStatuses = briefs.map(item => _.get(item, 'url_status.name')) || []
      state.filteredStatuses = state.statuses.filter(item => briefStatuses.includes(item.label)) || []
      const briefSections = briefs.map(item => _.get(item, 'section.name')) || []
      state.filteredSections = state.sections.filter(item => briefSections.includes(item)) || []
    } else {
      state.filteredStatuses = []
      state.filteredSections = []
    }
  },
  [types.ADD_STATUSES]: function (state, statuses) {
    state.statuses = statuses
  },
  [types.ADD_SECTIONS]: function (state, sections) {
    state.sections = sections
  },
  [types.CHANGE_ACTIVE_STATUS]: function (state, activeStatus) {
    state.activeStatus = state.statuses.includes(activeStatus) ? activeStatus : STATUS_ALL
  },
  [types.CHANGE_ACTIVE_SECTION]: function (state, activeSection) {
    state.activeSection = state.sections.includes(activeSection) ? activeSection : SECTION_ALL
  },
  [types.RESET_BRIEF_DATA]: function (state) {
    state.briefsList = []
  }
}

const actions = {
  getBriefOverviewData: async function ({ commit, dispatch }, clientId) {
    const response = await httpService.get(`content-briefs/list-content-briefs/${clientId}`)
    if (!response || !response.data) {
      return
    }
    const briefs = response.data
    const briefsToStore = briefs && Array.isArray(briefs) ? briefs : []
    commit(types.ADD_BRIEFS, briefsToStore)
  },
  addStatuses: function ({ commit }, statuses) {
    commit(types.ADD_STATUSES, statuses)
  },
  addSections: function ({ commit }, sections) {
    commit(types.ADD_SECTIONS, sections)
    commit(types.CHANGE_ACTIVE_SECTION, SECTION_ALL)
  },
  resetData ({ commit }) {
    commit(types.RESET_BRIEF_DATA)
  }
}

/**
 * Store manage data {@link BriefsOverview}
 */
export default {
  state,
  actions,
  mutations
}
